import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { BlockComponent } from "@components/container-block/block.component";
import { HeaderComponent } from "@components/header/header.component";
import { InputComponent } from "@components/input/input.component";
import { BusyService } from "~app/common/components/busy/busy.service";
import { DirtyFormService } from "~app/common/services/dirty-form.service";
import { Utils } from "~app/common/services/utils";
import { DirtyTabComponent } from "~app/features/regelverk-viol/dirtyTabComponent";
import { SystemadministrationService } from "../../systemadministration.service";

@Component({
    selector: "rask-sysadm-vacs",
    templateUrl: "./sysadm-vacs.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        BlockComponent,
        InputComponent,
        FormsModule,
        ButtonComponent
    ]
})
export class SysadmVacsComponent extends DirtyTabComponent {
    arbetsorderBeteckning: string;
    kontraktsNummer: string;

    private readonly administrationService = inject(SystemadministrationService);
    private readonly busyService = inject(BusyService);

    constructor() {
        const dirtyFormService = inject(DirtyFormService);

        super(dirtyFormService);
    }

    canSave() {
        // Tom, ingen användning här
    }

    exportXmlFromVacsKontrakt() {
        if (!this.isValidForExport()) {
            return;
        }

        const namn = this.arbetsorderBeteckning || this.kontraktsNummer;

        const observable = this.arbetsorderBeteckning ?
            this.administrationService.getVacsXmlArbetsorder(this.arbetsorderBeteckning) :
            this.administrationService.getVacsXmlVirkeskop(this.kontraktsNummer);

        this.busyService.addWork(observable)
            .subscribe(xmldata => {
                Utils.download(xmldata, `${namn}.xml`);
            });
    }

    isDirtyCheck(): boolean {
        return false;
    }

    isValidForExport(): boolean {
        return this.kontraktsNummer?.length > 0 || this.arbetsorderBeteckning?.length > 0;
    }

    restoreChanges() {
        // Tom, ingen användning här
    }

    saveChanges() {
        // Tom, ingen användning här
    }
}
